<template>
    <div class="vats-price">
        <Loader v-if="loader.data > 0"/>
        <template v-else>
            <VatsSelect
                :items="vatsItems"
                :currentVats="currentVats"
                :vatsSelecTitle="vatsSelectTitle"
                @change="(vats) => changeVats(vats)"
                v-if="!hideSelectVats"
            />
            <div class="row">
                <div :class="showOnlyNumbers && !readOnly ? 'col-lg-12' : 'col-lg-9'">
                    <div class="numbers">
                        <NumbersFilter
                            ref="filter"
                            :branches="branches"
                            :counters="counters"
                            :category.sync="category"
                            :isDemoVats="isDemoVats"
                            :showRegionSelect="showRegionSelect"
                            :regionSelectMultiple="regionSelectMultiple"
                            :showDetailSearch="showDetailSearch"
                            :motivationPopoverContent="chain !== 'virtual_number' ? motivationPopoverContent : null"
                            @selectBranch="showSelectBranchModal"
                            @applyFilter="(filter, isFiltered, patterns) => applyFilter(filter, isFiltered, patterns)"
                        />
                        <div class="numbers-type_main" data-element="numbers-container">
                            <NumbersGroupingToggle
                                v-if="showGrouping"
                                v-model="isGrouping"
                                :value.sync="groupingCount"
                                :disabled="reloading"
                            />
                            <Loader v-if="reloading" />
                            <template v-else>
                                <template v-if="!isEmpty">
                                    <NumbersGroup
                                        :isMobile="isMobile"
                                        :group="group"
                                        :branch="branchesGrouped[group.branchId]"
                                        :category="category"
                                        :isDemoVats="isDemoVats"
                                        :canBuyCount="canBuyCount"
                                        :viewMode="viewMode"
                                        :isFMC="isFMC"
                                        :isMVNO="isMVNO"
                                        :groupingCount="isGrouping ? groupingCount : 0"
                                        :numbersCountBeforeRegLink="numbersCountBeforeRegLink"
                                        :patterns="patterns"
                                        :loading="loader.page[group.id]"
                                        :blockLoading="loader.blocks"
                                        :key="group.id"
                                        :hideShowMoreBtn="numbersBlockLimit > 0"
                                        v-for="group in displayNumbersGroups"
                                        @load="load(group)"
                                        @addNumbers="(numbers, params) => addNumbers(numbers, params)"
                                        @removeNumbers="(numbers, params) => removeNumbers(numbers, params)"
                                        @changeProviderTariff="(provider, tariff) => changeProviderTariff(provider, tariff)"
                                    />
                                </template>
                                <template v-if="displayEmptyMessage">
                                    <div class="empty-numbers" data-element="empty-numbers">
                                        <div class="row">
                                            <div class="col-md-3 empty-numbers--icon">
                                                <span class="icon-mobile-phone"></span>
                                            </div>
                                            <div class="col-md-9 empty-numbers--text">
                                                <div v-html="displayEmptyMessage"/>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>
                    </div>
                    <template v-if="stepNote && !reloading">
                        <a name="step_note" id="step_note"></a>
                        <div class="step-note fs-sm text-gray" v-html="stepNote"/>
                    </template>
                </div>
                <Aside v-if="!showOnlyNumbers">
                    <template v-slot:miniCart>
                        <MiniCart
                            ref="cart"
                            :cart="cart"
                            :motivationPopoverContent="chain === 'virtual_number' ? motivationPopoverContent : null"
                            :loading="nextStepLoading"
                            @remove="(item) => removeCartItem(item)"
                            @submit="submit"
                        />
                    </template>
                    <template v-slot:portingForm>
                        <PortingForm
                            v-if="showPortingForm"
                        />
                    </template>
                    <template v-slot:nowBuying>
                        <NowBuying
                            :count="nowBuyingCount"
                            :timeFromShow="nowBuyingTimeFromShow"
                        />
                    </template>
                </Aside>
            </div>
        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import BaseApp from '../BaseApp';
import NumbersFilter from './components/NumbersFilter';
import NumbersGroup from './components/NumbersGroup';
import Loader from '../../components/ui/Loader';
import NumbersGroupingToggle from './components/NumbersGroupingToggle';
import Aside from './components/Aside';
import MiniCart from './components/MiniCart';
import PortingForm from './components/PortingForm';
import NowBuying from './components/NowBuying';
import VatsSelect from './components/VatsSelect';
import SelectBranchModal from './components/SelectBranchModal';
import ChangeVatsModal from './components/ChangeVatsModal';
import ModalConfirm from '../../components/ModalConfirm.vue'

import decoder from '../../lib/decoder';
import utils from '../../lib/utils';
import ModelBranch from './models/branch';
import ModelCategory from './models/category';
import ModelNumberGroup from './models/number_group';
import ModelCart from './models/cart';
import ModelCartItem from './models/cart_item';
import ModelVats from './models/vats';

import VModal from 'vue-js-modal';
Vue.use(VModal);

import api from '../../plugins/api'
Vue.use(api);

import message from '../../plugins/message'
Vue.use(message);

const VATS_VIRTUAL_NUMBER = 140667;
const VATS_BASE = 525691;
const VATS_EXTENDED = 525694;
const VATS_MAXIMIZED = 525697;

const COOKIE_NAME = 'selectedNumbers';

/* global BX */
/* global $ */

export default {
    name: "NumbersPage",
    mixins: [BaseApp],
    components: {
        NumbersFilter,
        NumbersGroupingToggle,
        NumbersGroup,
        Loader,
        Aside,
        MiniCart,
        PortingForm,
        NowBuying,
        VatsSelect
    },
    data() {
        return {
            allBranches: null,
            branches: [],
            counters: [],
            numbersGroups: [],
            category: '',
            isGrouping: false,
            groupingCount: 3,
            filter: null,
            isFiltered: false,
            needShowFilterMessage: false,
            patterns: null,
            cart: new ModelCart(),
            currentVats: null,
            vatsItems: [],
            vatsProducts: {},
            hideSelectVats: true,
            vatsSelectTitle: null,
            queue: {
                list: null,
                counters: null,
                numbers: {}
            },
            loader: {
                data: 1,
                reload: false,
                page: {},
                nextStep: false,
                blocks: {},
                numbers: 0
            },
            cartReloadTimeout: null,
            selectedNumbersCount: 0,
            miniCartReloadRequest: null //отменяемый фоновый запрос обновления мини корзины
        }
    },
    props: {
        // Мобильная версия
        isMobile: {
            type: Boolean,
            default: false
        },

        // Заголовок страницы
        title: {
            type: String,
            default: ''
        },

        // BX sessid
        sessid: {
            type: String,
            default: BX.bitrix_sessid()
        },

        // Символьный код цепочки покупки
        chain: {
            type: String,
            default: ''
        },

        // Символьный код категории номеров
        tab: {
            type: String,
            default: ''
        },

        // Символьный код приоритетного блока
        block_key: {
            type: String,
            default: ''
        },

        // Символьный код текущего шага цепочки покупки
        chainAction: {
            type: String,
            default: ''
        },

        // Отображать опцию группировки номеров по блокам
        canGroup: {
            type: Boolean,
            default: false
        },

        // Кейс покупки демо ВАТС
        isDemoVats: {
            type: Boolean,
            default: false
        },

        // Количество человек виджета "Сейчас покупают номера"
        nowBuyingCount: {
            type: Number,
            default: 0
        },

        // Через сколько секунд отображать виджет "Сейчас покупают номера"
        nowBuyingTimeFromShow: {
            type: Number,
            default: 0
        },

        // Количество выводимых номеров до показа ссылки на регистрацию
        // 0 - не выводить ссылку
        numbersCountBeforeRegLink: {
            type: Number,
            default: 0
        },

        // Отображать блок переноса номера
        showPortingForm: {
            type: Boolean,
            default: false
        },

        // Содержимое для popover в блоке категорий номеров
        motivationPopoverContent: {
            type: String
        },

        // Примечания для текущего шага покупки
        stepNote: {
            type: String
        },

        // Отображать только список номеров
        showOnlyNumbers: {
            type: Boolean,
            default: false
        },

        // Режим просмотра:
        // readonly - Просмотр номеров без возможности добавления в корзину
        // replace - Работает вместе с параметром addToCookie - выбор только одного номера и добавление в cookie
        viewMode: {
            type: String,
            default: ''
        },

        // Текущая корзина
        cartItems: {
            type: Object
        },

        // Информация по ВАТС: список текущего клиента, текущая, доступные и т.д.
        vats: {
            type: Object
        },

        // Код текущей ВАТС
        currentVatsCode: {
            type: String
        },

        // Тариф текущей ВАТС
        currentVatsTariff: {
            type: String
        },

        // Ссылка следующего шага покупки
        nextStepUrl: {
            type: Object
        },

        // Добавлять номера не в корзину, а в cookie
        addToCookie: {
            type: Boolean,
            default: false
        },

        // ИД регионов, для которых включена упрощенная покупка
        // Упрощенная покупка: если в корзине добавлен 1 номер из этого региона,
        // то автоматически добавляется ВАТС "Виртуальный номер" и происходит редирект в корзину
        noTariffRegions: {
            type: Array
        },
        //пресет фильтра номеров
        anchor: {
            type: String
        },
        //префиксы для исключения номеров из выборки
        excludePrefix: {
            type: Array
        },

        numbersBlockLimit: {
            type: Number,
            default: 0
        },

        defaultBranchId: {
            type: Number,
            default: 0
        },

        backUrl: {
            type: String,
            default: ''
        },

        backText: {
            type: String,
            default: ''
        },

        stepCount: {
            type: Number,
            default: 0
        },

        stepCurrent: {
            type: Number,
            default: 0
        },

        showRegionSelect: {
            type: Boolean,
            default: true
        },

        regionSelectMultiple: {
            type: Boolean,
            default: true
        },

        showDetailSearch: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        defaultCategory() {
            if (this.tab) {
                return ModelCategory.constants.code[this.tab];
            }

            return ModelCategory.constants.code.usual;
        },
        reloading() {
            return this.queue.list !== null || this.queue.counters !== null
        },
        canBuyCount() {
            let limit = 0;
            if (this.currentVats) {
                limit = this.currentVats.limit - this.currentVats.connectedCount;
            }

            if (isNaN(this.selectedNumbersCount)) {
                return limit;
            }

            return limit - this.selectedNumbersCount;
        },
        nextStepLoading() {
            return this.loader.nextStep || this.loader.numbers > 0
        },
        branchesGrouped() {
            let grouped = {};
            this.branches.forEach(branch => {
                grouped[branch.id] = branch;
            })
            return grouped;
        },
        branchPrefix() {
            if (!this.isMobile) {
                return null
            }
            let branches = this.branches.filter(branch => branch.selected);
            if (branches.length > 0) {
                return branches[0].prefix
            }
            return null
        },
        isFMC() {
            return this.chainAction === 'fmc'
        },
        isMVNO() {
            return this.chainAction === 'mvno'
        },
        showGrouping() {
            return this.canGroup && !this.isDemoVats && !this.isMVNO && this.viewMode !== 'replace'
        },
        displayNumbersGroups() {
            let sorted = this.numbersGroups
                .filter(group => Array.isArray(group.items) && group.items.length > 0)
                .sort((a, b) => {
                    return +b.isUpsale - a.isUpsale
                })

            if (this.isMobile) {
                return this.groupNumberGroupsByCategory(sorted);
            }

            return sorted;
        },
        isEmpty() {
            return this.displayNumbersGroups.length === 0
        },
        displayEmptyMessage() {
            if (this.isFiltered) {
                if (this.isEmpty) {
                    return `К сожалению, в выбранных регионах мы не нашли номеров, соответствующим вашим критериям.
                            Позвоните по номеру <a class="text-gray dashed" href="tel:88005555522">8 800 <span>555 55 22</span></a>
                            или <a class="text-gray dashed" data-form-block="NUMBERS_HELP" data-type="link">оставьте заявку</a>,
                            и мы подберем вам номер.`
                }
            } else {
                let notEmptyBranches = {};
                this.displayNumbersGroups.forEach(group => {
                    if (group.nav && group.nav.count > 0) {
                        notEmptyBranches[group.branchId] = true;
                    }
                });

                let emptyBranches = []
                this.branches.forEach(branch => {
                    if (branch.selected) {
                        if (notEmptyBranches[branch.id] !== true) {
                            emptyBranches.push(branch.name);
                        }
                    }
                });

                let emptyCount = emptyBranches.length;
                if (emptyCount > 0) {
                    let branches = (emptyCount > 1) ? `выбранных регионах  (${ emptyBranches.join(', ') })` : `выбранном регионе  ${ emptyBranches[0] }`;
                    return `К сожалению, в ${ branches } мы не нашли номеров, соответствующих вашим критериям.
                            Позвоните по номеру <a class="text-gray dashed" href="tel:88005555522">8 800 <span>555 55 22</span></a>
                            или <a class="text-gray dashed" data-form-block="NUMBERS_HELP" data-type="link">оставьте заявку</a>,
                            и мы поможем вам с выбором.`
                }
            }
            return null
        }
    },
    watch: {
        isGrouping() {
            this.reload();
        },
        groupingCount() {
            this.reload();
        }
    },
    beforeDestroy() {
        $(document).off('add_porting_number', this.onPortingNumberAdd);
    },
    mounted() {
        this.initData()
            .finally(() => {
                this.onDataInit();
                this.loader.data--;
            })
        $(document).on('add_porting_number', this.onPortingNumberAdd);
    },
    methods: {
        groupNumberGroupsByCategory(sortedNumberGroups) {
            let grouped = {};

            for (let key in sortedNumberGroups) {
                if (grouped[sortedNumberGroups[key].category] === undefined) {
                    grouped[sortedNumberGroups[key].category] = {};
                }

                grouped[sortedNumberGroups[key].category][key] = sortedNumberGroups[key];
            }

            this.numberGroupsByCategory = grouped;

            return grouped;
        },
        onDataInit() {
            this.cart = decoder.decode(ModelCart, this.cartItems);

            this.selectedNumbersCount = this.cart.getSelectedNumbersCount([
                ModelCart.constants.type.numbers,
                ModelCart.constants.type.portingNumbers
            ]);

            this.initVatsData();

            this.loader.data++;

            let params = {
                chain: this.chain
            };
            if (this.anchor) {
                params.anchor = this.anchor
            }
            if (this.chainAction) {
                params.chainAction = this.chainAction
            }

            if (this.defaultBranchId > 0) {
                params.branch_id = this.defaultBranchId
            }

            this.request('branches-preset', 'get', params)
                .then((r) => {
                    if (Array.isArray(r.result)) {
                        let branches = decoder.decode(ModelBranch, r.result);
                        this.branches = branches.map(branch => {
                            branch.selected = true;
                            return branch;
                        });
                    }
                    this.loader.data--;
                })
                .catch((r) => {
                    this.loader.data--;
                    if (r.error) {
                        this.$showWarning(r.error);
                    }
                })
        },
        initVatsData() {
            if (!this.vats) {
                return;
            }

            this.currentVats = decoder.decode(ModelVats, this.vats);

            if (Array.isArray(this.vats['VATS_LIST'])) {
                this.vatsItems = decoder.decode(ModelVats, this.vats['VATS_LIST']);
            }

            if (this.vats['VATS_PRODUCTS']) {
                for (let id in this.vats['VATS_PRODUCTS']) {
                    if (Object.hasOwnProperty.call(this.vats['VATS_PRODUCTS'], id)) {
                        let vats = decoder.decode(ModelVats, this.vats['VATS_PRODUCTS'][id]);
                        vats.id = decoder.intValue(id, 0);
                        this.vatsProducts[id] = vats;
                    }
                }
            }

            this.hideSelectVats = decoder.boolValue(this.vats['HIDE_SELECT'], true);
            this.vatsSelectTitle = decoder.stringValue(this.vats['TITLE'], '');
        },
        applyFilter(filter, isFiltered, patterns) {
            this.filter = filter;
            this.isFiltered = isFiltered;
            this.needShowFilterMessage = isFiltered;
            this.patterns = patterns;
            this.reload();
        },
        reload() {
            let isEmpty = !(Array.isArray(this.filter.branch_id) && this.filter.branch_id.length > 0);
            if (isEmpty) {
                this.counters.forEach(counter => {
                    counter.count = 0;
                });
                this.numbersGroups.splice(0);
                return;
            }
            this.reloadCounters();
        },
        setDefaultCategory() {
            if (!this.category) {
                this.category = this.defaultCategory;
                this.filter.beauty = [this.category];
            }
        },
        reloadCounters() {
            this.setDefaultCategory();
            let params = this.filter ? Object.assign({}, this.filter) : {};
            if (this.isFMC) {
                params.fmc = 1;
            }
            if (this.isMVNO) {
                params.mvno = 1;
            }
            if (this.isMobile && this.branchPrefix) {
                params.digits = this.branchPrefix;
                params.begins = 1;
            }
            if (this.excludePrefix) {
                params.excludePrefix = this.excludePrefix;
            }
            let selectCategory = '';
            let promise = this.request('beauty', 'get', params)
                .then((r) => {
                    if (this.queue.counters !== promise) {
                        return;
                    }
                    if (Array.isArray(r.result)) {
                        this.runViewProductEcommerceEvents(r);

                        for (let i = 0; i < r.result.length; i++) {
                            if (r.result[i].count > 0) {
                                if (r.result[i].code === this.category) {
                                    selectCategory = '';
                                    break;
                                } else if (selectCategory.length === 0) {
                                    selectCategory = r.result[i].code;
                                }
                            }
                        }
                        if (selectCategory.length > 0 && !this.isMobile) {
                            this.category = selectCategory;
                            this.filter.beauty = [this.category];
                        }
                        this.counters = decoder.decode(ModelCategory, r.result);
                    } else {
                        this.counters.splice(0);
                    }
                    this.queue.counters = null;

                    this.reloadList();
                })
                .catch(() => {
                    if (this.queue.counters === promise) {
                        this.queue.counters = null;
                    }
                });
            this.queue.counters = promise;
        },
        reloadList() {
            let params = this.filter ? Object.assign({}, this.filter) : {};
            if (this.isGrouping) {
                params.group = this.groupingCount;
            }
            if (this.block_key) {
                params.block_key = this.block_key;
            }
            if (this.isFMC) {
                params.fmc = 1;
            }
            if (this.isMVNO) {
                params.mvno = 1;
            }
            if (this.excludePrefix) {
                params.excludePrefix = this.excludePrefix;
            }
            if (this.isMobile) {
                let selectedBranches = this.branches.filter(function (el) {
                    return el.selected
                });
                if (this.branchPrefix && selectedBranches.length <= 1) {
                    params.digits = this.branchPrefix;
                    params.begins = 1;
                }
            } else {
                if (this.branchPrefix) {
                    params.digits = this.branchPrefix;
                    params.begins = 1;
                }
            }
            if (this.numbersBlockLimit) {
                params.blockLimit = this.numbersBlockLimit
            }

            let promise = this.request('list', 'get', params)
                .then((r) => {
                    if (this.queue.list !== promise) {
                        return;
                    }
                    if (Array.isArray(r.result)) {
                        this.numbersGroups = decoder.decode(ModelNumberGroup, r.result, this.cart);
                        if (this.cartItems['NUMBERS_FOR_HIDE'].length > 0) {
                            this.numbersGroups.forEach((group) => {
                                group.items = group.items.filter((number) => {
                                    return this.cartItems['NUMBERS_FOR_HIDE'].indexOf(number.id) < 0
                                });
                            });
                        }
                    } else {
                        this.numbersGroups.splice(0);
                    }
                    this.showFilterMessage();
                    this.queue.list = null;
                })
                .catch(() => {
                    if (this.queue.list === promise) {
                        this.queue.list = null;
                    }
                });

            this.queue.list = promise;
        },
        load(group) {
            this.$set(this.loader.page, group.id, true);

            let params = {
                page: group.nav.page + 1,
                block_id: group.id
            }
            if (this.isFMC) {
                params.fmc = 1;
            }
            if (this.isMVNO) {
                params.mvno = 1;
            }
            params = this.filter ? Object.assign(params, this.filter) : params;

            if (this.isMobile) {
                let selectedBranches = this.branches.filter(function (el) {
                    return el.selected
                });

                if (this.branchPrefix && selectedBranches.length <= 1) {
                    params.digits = this.branchPrefix;
                    params.begins = 1;
                }
            } else {
                if (this.branchPrefix) {
                    params.digits = this.branchPrefix;
                    params.begins = 1;
                }
            }

            this.request('list', 'get', params)
                .then((r) => {
                    let nextPageGroups = decoder.decode(ModelNumberGroup, r.result, this.cart);
                    if (Array.isArray(nextPageGroups) && nextPageGroups.length > 0) {
                        group.append(nextPageGroups[0])
                    }
                })
                .catch(() => {
                    this.$showError('Ошибка загрузки номеров');
                })
                .finally(() => {
                    this.$set(this.loader.page, group.id, false);

                    if (this.isMobile) {
                        this.updateSlider();
                    }
                });

            $(window).resize();
        },
        reloadCart() {
            if (typeof window.ReloadMiniBasket !== 'undefined') {
                window.ReloadMiniBasket();
            }

            let data = {
                'type': 'mini_cart',
                'json': true
            };
            if (this.miniCartReloadRequest !== null) {
                this.miniCartReloadRequest.cancel();
            }

            this.miniCartReloadRequest = this.$api.request('/api/cart/reload/', 'post', data, true);
            this.miniCartReloadRequest.promise
                .then((response) => {
                    if (response?.data?.status === 'success' && response.data.result) {
                        let cart = ModelCart.create(response.data.result);
                        if (cart) {
                            this.cart.refresh(cart)
                        }
                    }
                    this.miniCartReloadRequest = null;
                });
        },
        showSelectBranchModal() {
            this.$modal.show(SelectBranchModal, {
                selectedBranches: this.branches.filter(branch => branch.selected),
                loadBranchesFunction: () => {
                    return new Promise((resolve, reject) => {
                        if (Array.isArray(this.allBranches)) {
                            resolve(this.allBranches);
                            return;
                        }

                        let params = {};
                        if (this.isFMC) {
                            params['fmc'] = 1;
                        }
                        if (this.isMVNO) {
                            params['mvno'] = 1;
                        }

                        this.request('branches', 'get', params)
                            .then((r) => {
                                let branches = decoder.decode(ModelBranch, r.result);
                                if (!Array.isArray(branches)) {
                                    branches = [];
                                }
                                this.allBranches = branches;
                                resolve(branches);
                            })
                            .catch(() => {
                                reject([]);
                            })
                    })
                },
                selectBranchFunction: (branch) => {
                    if (!this.regionSelectMultiple) {
                        this.branches = [];
                    }
                    this.addBranch(branch);
                }
            }, {
                scrollable: true,
                width: 768,
                height: 'auto'
            });

            this.setNumbersLocationClick();
        },
        addBranch(branch) {
            let index = this.branches.findIndex(b => b.key === branch.key);
            if (index > -1) {
                this.branches[index].selected = true;
                this.branches.unshift(this.branches.splice(index, 1)[0]);
            } else {
                branch.selected = true;
                this.branches.unshift(branch);
            }
        },
        request(action, method, data) {
            let url = this.apiUrl + action + '/?sessid=' + this.sessid;
            return this.$api.request(url, method, data);
        },
        showFilterMessage() {
            if (!this.needShowFilterMessage) {
                return;
            }
            this.needShowFilterMessage = false;

            let count = 0;
            this.numbersGroups.forEach(group => {
                if (group.nav) {
                    count += group.nav.count;
                }
            });
            if (count > 0) {
                this.$showSuccess(utils.declOfNum(count, [
                    `Найден ${count} номер`,
                    `Найдено ${count} номера`,
                    `Найдено ${count} номеров`
                ], false));
            } else {
                if (this.isMobile) {
                    this.$showWarning(`По указанным критериям номера не найдены`);
                } else {
                    this.$showWarning(`Для выбранных условий поиска сейчас нет доступных номеров.
                    Позвоните нам по номеру <a class="text-white dashed" href="tel:88005555522">8 800 555 55 22</a>
                    и мы поможем вам с выбором.`);
                }
            }
        },
        updateSelectedNumbersFromCart() {
            this.numbersGroups.forEach(group => {
                group.fillSelectedNumbers(this.cart);
            });
        },
        toggleNumberSelected(numbersId, status) {
            if (typeof numbersId === 'number') {
                numbersId = [numbersId];
            }
            if (status) {
                this.selectedNumbersCount += numbersId.length;
            } else {
                this.selectedNumbersCount -= numbersId.length;
            }
            this.numbersGroups.forEach(group => {
                group.toggleNumberSelected(numbersId, status);
            });
        },
        toggleNumberError(numbersId, hasError) {
            this.numbersGroups.forEach(group => {
                group.toggleNumberError(numbersId, hasError);
            });
        },
        onPortingNumberAdd(e, number) {
            if (number) {
                this.cart.add(ModelCartItem.createFromPortingNumber(number));
            }
        },
        removeCartItem(item) {
            if (item.type === ModelCart.constants.type.portingNumbers) {
                $(document).trigger('remove_porting_number', item.id);
                this.cart.remove(item);
            } else {
                this.removeNumbers([item]);
            }
        },
        // items - [ModelCartItem]
        addNumbers(items, params) {
            if (this.addToCookie) {
                this.addNumbersToCookie(items);
                return;
            }

            if (!params) {
                params = {};
            }

            if (params.blockId && this.loader.blocks[params.blockId] === true) {
                return;
            }

            if (!this.checkNumbersLimit(items.length)) {
                return;
            }

            if (!this.checkOtherFmcProvider(items, params)) {
                return;
            }

            let numbersId = items.map(item => item.numberId);

            this.toggleNumberSelected(numbersId, true);
            this.toggleNumberError(numbersId, false);

            if (items.length > 1) {
                if (params.blockId) {
                    this.$set(this.loader.blocks, params.blockId, true);
                }

                let numbers = [];
                let itemsById = {};
                items.forEach((item) => {
                    numbers.push({
                        id: item.numberId,
                        tariffId: item.tariffId
                    });
                    itemsById[item.numberId] = item;
                });

                let data = {
                    numbers: JSON.stringify(numbers),
                    sessid: this.sessid,
                    backurl: location.href
                };

                this.loader.numbers++;
                this.$api.request('/api/cart/add_numbers/', 'post', data)
                    .then((r) => {
                        let errorItemsById = {};
                        if (r) {
                            let errors = [];
                            for (let id in r) {
                                if (Object.hasOwnProperty.call(r, id)) {
                                    let response = r[id];
                                    if (response.status !== 'success') {
                                        if (response.message) {
                                            if (itemsById[id]) {
                                                response.message = response.message.replace('данный номер', itemsById[id].name);
                                            }
                                            errors.push(response.message);
                                        }
                                        this.toggleNumberSelected(id, false);
                                        this.toggleNumberError(id, true);
                                        errorItemsById[id] = true;
                                    }
                                }
                            }
                            if (errors.length > 0) {
                                this.$showError(errors.join('<br />'));
                            }
                        }

                        items.forEach((item) => {
                            if (errorItemsById[item.numberId] !== true) {
                                this.cart.add(item);
                            }
                        });

                        clearTimeout(this.cartReloadTimeout);
                        this.cartReloadTimeout = setTimeout(() => {
                            this.reloadCart();
                        }, 1000);

                        if (typeof window.mgoTriggerEvent !== 'undefined') {
                            window.mgoTriggerEvent('add_numbers');
                        }

                        this.$emit('add_numbers', {
                            status: true
                        });
                    })
                    .catch((r) => {
                        let error = r.message || r.error;
                        if (error) {
                            this.$showError(error);
                        }

                        this.toggleNumberSelected(numbersId, false);
                        this.toggleNumberError(numbersId, true);

                        this.$emit('add_numbers', {
                            status: false
                        });
                    })
                    .finally(() => {
                        this.loader.numbers--;
                        if (params.blockId) {
                            this.$set(this.loader.blocks, params.blockId, false);
                        }
                    })
            } else {
                if (utils.isFunction(params.chooseRandomCallback)) {
                    params.chooseRandomCallback();
                }
                items.forEach(item => {
                    let request = this.queue.numbers[item.numberId];
                    if (request) {
                        request.cancel();
                        this.queue.numbers[item.numberId] = null;
                    }

                    this.loader.numbers++;

                    let data = {
                        id: item.numberId,
                        tariffId: item.tariffId,
                        sessid: this.sessid,
                        backurl: location.href,
                        chainFirstUrl: location.href
                    };

                    request = this.$api.request('/api/cart/add_number/', 'post', data, true);
                    this.queue.numbers[item.numberId] = request;

                    request.promise
                        .then((response) => {
                            this.queue.numbers[item.numberId] = null;
                            if (response.data.prices && response.data.prices[item.numberId]) {
                                let priceToUpdate = response.data.prices[item.numberId];
                                item.priceMonthly = priceToUpdate.priceMonthly;
                                item.priceMonthlyFull = priceToUpdate.priceMonthlyFull;
                                item.priceOnce = priceToUpdate.priceOnce;
                                item.priceOnceFull = priceToUpdate.priceOnceFull;
                            }

                            this.cart.add(item);

                            clearTimeout(this.cartReloadTimeout);
                            this.cartReloadTimeout = setTimeout(() => {
                                this.reloadCart();
                            }, 1000);

                            if (typeof window.mgoTriggerEvent !== 'undefined') {
                                window.mgoTriggerEvent('add_number');
                                this.runAddOrDelProductCartEcommerceEvents(response.data);
                            }

                            this.$emit('add_number', {
                                status: true
                            });
                        })
                        .catch((r) => {
                            if (r.isCancel) {
                                return;
                            }

                            let error = r.message || r.error;
                            if (error) {
                                this.$showError(error);
                            }

                            this.toggleNumberSelected(item.numberId, false);
                            this.toggleNumberError(item.numberId, true);

                            this.$emit('add_number', {
                                status: false
                            });
                        })
                        .finally(() => {
                            this.loader.numbers--;
                        })
                });
            }
        },
        // items - [ModelCartItem]
        removeNumbers(items, params) {
            if (this.addToCookie) {
                this.removeNumbersFromCookie(items);
                return;
            }

            if (!params) {
                params = {};
            }

            if (params.blockId && this.loader.blocks[params.blockId] === true) {
                return;
            }

            let numbersId = items.map(item => item.numberId);

            items.forEach(item => {
                this.cart.remove(item);
            });

            if (items.length > 1) {
                if (params.blockId) {
                    this.$set(this.loader.blocks, params.blockId, true);
                }

                let numbers = [];
                items.forEach((item) => {
                    numbers.push(item.numberId);
                });

                let data = {
                    id_list: numbers,
                    sessid: this.sessid,
                    backurl: location.href
                };

                this.loader.numbers++;
                this.$api.request('/api/cart/remove_numbers/', 'delete', data)
                    .then(() => {
                        this.toggleNumberSelected(numbersId, false);
                        this.toggleNumberError(numbersId, false);
                        clearTimeout(this.cartReloadTimeout);
                        this.cartReloadTimeout = setTimeout(() => {
                            this.reloadCart();
                        }, 1000);

                        if (typeof window.mgoTriggerEvent !== 'undefined') {
                            window.mgoTriggerEvent('remove_numbers');
                        }

                        this.$emit('remove_numbers', {
                            status: true
                        });
                    })
                    .catch((r) => {
                        let error = r.message || r.error;
                        if (error) {
                            this.$showError(error);
                        }

                        this.$emit('remove_numbers', {
                            status: false
                        });
                    })
                    .finally(() => {
                        this.loader.numbers--;
                        if (params.blockId) {
                            this.$set(this.loader.blocks, params.blockId, false);
                        }
                    })
            } else {
                items.forEach(item => {
                    let request = this.queue.numbers[item.numberId];
                    if (request) {
                        request.cancel();
                        this.queue.numbers[item.numberId] = null;
                    }

                    this.loader.numbers++;

                    let data = {
                        id: item.numberId,
                        sessid: this.sessid,
                        backurl: location.href
                    };

                    request = this.$api.request('/api/cart/remove_number/', 'delete', data, true);
                    this.queue.numbers[item.numberId] = request;

                    request.promise
                        .then((response) => {
                            this.toggleNumberSelected(numbersId, false);
                            this.toggleNumberError(numbersId, false);
                            this.queue.numbers[item.numberId] = null;

                            clearTimeout(this.cartReloadTimeout);
                            this.cartReloadTimeout = setTimeout(() => {
                                this.reloadCart();
                            }, 1000);

                            if (typeof window.mgoTriggerEvent !== 'undefined') {
                                window.mgoTriggerEvent('remove_number');
                                this.runAddOrDelProductCartEcommerceEvents(response);
                            }

                            this.$emit('remove_number', {
                                status: true
                            });
                        })
                        .catch((r) => {
                            if (r.isCancel) {
                                return;
                            }
                            let error = r.message || r.error;
                            if (error) {
                                this.$showError(error);
                            }

                            this.$emit('remove_number', {
                                status: false
                            });
                        })
                        .finally(() => {
                            this.loader.numbers--;
                        })
                });
            }
        },
        addNumbersToCookie(items) {
            if (items.length === 0) {
                return;
            }

            let numbers = $.cookie(COOKIE_NAME);
            if (!numbers) {
                numbers = {};
            } else {
                numbers = $.parseJSON(numbers);
            }

            if (this.viewMode === 'replace') {
                numbers = {};
                items.splice(1);
                this.cart.removeAll();
            }

            items.forEach(item => {
                numbers[item.numberId] = {
                    name: item.name,
                    tariffId: item.tariffId
                };

                this.cart.add(item);
            });

            this.numbersGroups.forEach(group => {
                group.fillSelectedNumbers(this.cart);
            });

            $.cookie(COOKIE_NAME, JSON.stringify(numbers));
        },
        removeNumbersFromCookie(items) {
            if (items.length === 0) {
                return;
            }

            let removeById = {};
            items.forEach(item => {
                removeById[item.numberId] = true;
                this.cart.remove(item);
            });

            let numbers = $.cookie(COOKIE_NAME);
            if (numbers) {
                numbers = $.parseJSON(numbers);

                let newNumbers = {};
                for (let numberId in numbers) {
                    if (Object.hasOwnProperty.call(numbers, numberId) && !Object.hasOwnProperty.call(removeById, numberId)) {
                        newNumbers[numberId] = numbers[numberId];
                    }
                }

                $.cookie(COOKIE_NAME, JSON.stringify(newNumbers));
            }

            this.numbersGroups.forEach(group => {
                group.fillSelectedNumbers(this.cart);
            });
        },
        checkNumbersLimit(quantity) {
            if (this.chain === 'cov' || this.isFMC) {
                return true;
            }

            quantity = quantity || 1;

            let limit = 0;
            if (this.currentVats) {
                limit = this.currentVats.limit - this.currentVats.connectedCount;
            }

            let count = this.selectedNumbersCount + quantity;

            if (count <= limit) {
                return true;
            }

            let vatsBase = this.vatsProducts[VATS_BASE] || null;
            let vatsExtended = this.vatsProducts[VATS_EXTENDED] || null;
            let vatsMaximized = this.vatsProducts[VATS_MAXIMIZED] || null;

            if (!vatsBase || !vatsExtended || !vatsMaximized) {
                this.$showError('Превышен лимит номеров. Выберите более высокую версию Виртуальной АТС.');
                return false;
            }

            if (limit > vatsExtended.limit || (this.currentVats && (this.currentVats.isDemo || this.currentVats.anchor !== 'new'))) {
                this.$showError('Для выбранной версии продукта установлен лимит номеров - ' + limit + '. Выберите более высокую версию Виртуальной АТС.');
                return false;
            }

            let vats = vatsMaximized;
            if (limit === vatsBase.limit) {
                vats = vatsExtended;
            } else if (limit === 1) {
                vats = vatsBase;
            }

            this.$modal.show(ChangeVatsModal, {
                currentVats: this.currentVats,
                vats: vats,
                limit: limit
            }, {
                scrollable: true,
                width: this.isMobile ? '100%' : 768,
                height: 'auto'
            });

            return false;
        },
        // items - ModelCartItem
        checkOtherFmcProvider(items, params) {
            if (!this.isFMC || items.length === 0) {
                return true;
            }

            let providerId = items[0].providerId;
            if (providerId <= 0) {
                return true;
            }

            let otherItems = this.cart
                .getItems(ModelCart.constants.type.fmcNumbers)
                .filter(item => item.providerId !== providerId);

            if (otherItems.length === 0) {
                return true;
            }

            this.$modal.show(ModalConfirm,
                {
                    body: 'Вы уже выбрали номера другого оператора. В одном заказе можно выбрать номера только одного оператора. Хотите удалить выбранные номера из заказа, и выбрать новые?',
                    okTitle: 'Да',
                    cancelTitle: 'Нет',
                    confirmFunction: () => {
                        this.removeNumbers(otherItems);
                        this.addNumbers(items, params);
                    }
                },
                {
                    adaptive: true,
                    height: 'auto',
                }
            );

            return false;
        },
        changeVats(vats) {
            this.loader.nextStep = true;
            let t = this;

            let data = {
                sessid: this.sessid,
                backurl: location.href,
                anchor: vats.anchor,
                billingId: vats.billingId,
                connectedNumCount: vats.connectedCount
            };

            fetch('/api/chain/change_current_vats/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(data),
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response?.data?.status === 'success') {
                    let params = new URLSearchParams(location.search);
                    params.set('productId', vats.anchor);
                    location.search = params.toString();
                } else {
                    let msg = response?.data?.message;
                    if (!msg) {
                        msg = response?.errors[0]?.message;
                    }
                    if (!msg) {
                        msg = 'Что-то пошло не так... Приносим свои извинения. Пожалуйста, позвоните по телефону: 8 800 555 55 22. Вам обязательно помогут.';
                    }
                    t.$showError(msg);

                    t.loader.nextStep = false;
                }
            }).catch(function (err) {
                console.log(err);
                t.loader.nextStep = false;
            });
        },
        changeProviderTariff(provider, tariff) {
            if (this.addToCookie || !provider || !tariff) {
                return;
            }

            let items = [];
            this.cart.getItems(ModelCart.constants.type.fmcNumbers).forEach(item => {
                if (item.providerId === provider.id && item.tariffId !== tariff.id) {
                    items.push(item)
                }
            });

            if (items.length === 0) {
                return;
            }

            if (this.addToCookie) {
                this.removeNumbersFromCookie(items);
                items.forEach(item => {
                    item.tariffId = tariff.id
                });
                this.addNumbers(items);
                return;
            }

            items.forEach(item => {
                this.cart.remove(item);
                item.tariffId = tariff.id;
                this.cart.add(item);
            });

            let numbers = [];
            items.forEach((item) => {
                numbers.push(item.numberId);
            });

            let data = {
                id_list: numbers,
                tariffId: tariff.id,
                sessid: this.sessid,
                backurl: location.href
            };

            this.loader.numbers++;
            this.$api.request('/api/cart/change_numbers/', 'post', data)
                .then(() => {
                    clearTimeout(this.cartReloadTimeout);
                    this.cartReloadTimeout = setTimeout(() => {
                        this.reloadCart();
                    }, 1000);

                    if (typeof window.mgoTriggerEvent !== 'undefined') {
                        window.mgoTriggerEvent('change_numbers');
                    }

                    this.$emit('change_numbers', {
                        status: true
                    });
                })
                .catch((r) => {
                    let error = r.message || r.error;
                    if (error) {
                        this.$showError(error);
                    }

                    this.$emit('change_numbers', {
                        status: false
                    });
                })
                .finally(() => {
                    this.loader.numbers--;
                })
        },
        submit() {
            let count = this.cart.getSelectedNumbersCount([
                ModelCart.constants.type.numbers,
                ModelCart.constants.type.fmcNumbers,
                ModelCart.constants.type.mvnoNumbers
            ]);

            if (count === 0) {
                if (this.currentVatsCode === 'virtual_number') {
                    this.$showWarning('Версия "Виртуальный номер" доступна для продажи только с номером MANGO OFFICE.');
                } else if (this.currentVats && this.currentVats.isDemo) {
                    this.$showWarning('Нельзя приобрести демо-версию Виртуальной АТС без номера.');
                } else if (this.cart.getSelectedNumbersCount([ModelCart.constants.type.portingNumbers]) > 0) {
                    this.nextChainStep();
                } else if (this.currentVatsTariff && this.currentVatsTariff !== 'plan-0') {
                    this.$showWarning('Нельзя приобрести Виртуальную АТС без номеров.');
                } else {
                    this.$modal.show(ModalConfirm,
                        {
                            body: 'Для использования услуг телефонной связи вам необходим телефонный номер. Вы сможете подключить свои телефонные номера или номера MANGO OFFICE позже. Хотите продолжить?',
                            okTitle: 'Да',
                            cancelTitle: 'Нет',
                            confirmFunction: () => {
                                window.location.href = this.currentVatsTariff ? '/shop/cart/?setCurrentChain=vats_as_soft' : '/shop/tariffs/vpbx/?setCurrentChain=vats_as_soft';
                            }
                        },
                        {
                            adaptive: true,
                            height: 'auto',
                        }
                    );
                }
            } else {
                let triggerEvent = window.metrikaTriggerEvent
                if (typeof triggerEvent !== 'undefined') {
                    if (count >= 5) {
                        triggerEvent('5_number_chosen')
                    } else if (count === 4) {
                        triggerEvent('4_number_chosen')
                    } else if (count === 3) {
                        triggerEvent('3_number_chosen')
                    } else if (count === 2) {
                        triggerEvent('2_number_chosen')
                    } else if (count === 1) {
                        triggerEvent('1_number_chosen')
                    }
                }

                if (this.isFMC) {
                    if (this.cart.getSelectedNumbersCount([ModelCart.constants.type.fmcNumbers]) === 0) {
                        this.$showWarning('Для использования услуг телефонной связи с номером FMC вам необходим городской телефонный номер.');
                        return;
                    }
                } else {
                    if (count === 1 && Array.isArray(this.noTariffRegions)) {
                        let numberItems = this.cart.getItems(ModelCart.constants.type.numbers);
                        if (numberItems.length > 0 && numberItems[0].branchId > 0) {
                            if (this.noTariffRegions.map(id => parseInt(id)).indexOf(numberItems[0].branchId) > -1) {
                                this.loader.nextStep = true;
                                if (typeof window.selectVats === 'undefined') {
                                    return;
                                }
                                window.selectVats({
                                    "id": VATS_VIRTUAL_NUMBER,
                                    "chain": "numbers",
                                    "redirect": "/shop/cart/"
                                });
                                return;
                            }
                        }
                    }
                }

                this.nextChainStep()
            }
        },
        nextChainStep() {
            this.loader.nextStep = true;

            let data = {
                sessid: this.sessid,
                backurl: location.href
            };

            fetch('/api/chain/next_step_url/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify(data),
            }).then(function (response) {
                return response.json();
            }).then(function (response) {
                if (response?.data?.url) {
                    location.href = response.data.url;
                }
            }).catch(function () {
                this.loader.nextStep = false;
            });
        },
    }
}
</script>

<style lang="scss">
.vm--container.scrollable {
    padding-top: 30px;
    padding-bottom: 30px;
}

.vm--overlay {
    background-color: rgba(0, 0, 0, 0.6) !important;
}

.numbers-group + .empty-numbers {
    margin-top: 50px;
}
.icon-mobile-phone {
    position: relative;
    display: block;
    color: #607D8B;
    height: 100%;
    &:before {
        content: " ";
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        height: 100%;
        width: 100%;
        background: url(/static_files_new/scss/blocks/8800/img/mobile_phone.svg) center no-repeat;
        background-size: contain;
    }
}
</style>